import * as React from 'react';
import cn from 'classnames';

import { IconSize } from 'shared/entities/components/Icon';
import { useTypedTranslation } from 'shared/entities/localization';
import ArrowIcon from 'shared/newComponents/icons/ArrowIcon';

import styles from './NewsModalCarouselNavigation.modules.scss';

type Props = {
  activeIndex: number;
  items: Array<{ id: string }>;
  nextDisabled: boolean;
  onNext: () => void;
  onPrevious: () => void;
  onSelect: (index: number) => void;
  paginationStart: number;
  previousDisabled: boolean;
  withArrows: boolean;
};

const NewsModalCarouselNavigation: React.FC<Props> = ({
  activeIndex,
  items,
  nextDisabled,
  onNext,
  onPrevious,
  onSelect,
  paginationStart,
  previousDisabled,
  withArrows
}) => {
  const { t } = useTypedTranslation('app');

  return (
    <div
      className={cn(
        styles['news-modal-carousel-navigation'],
        !withArrows && styles['news-modal-carousel-navigation_pagination']
      )}
    >
      {withArrows && (
        <button
          aria-label={t('news.navigation.previous')}
          disabled={previousDisabled}
          className={styles['news-modal-carousel-navigation__arrow']}
          type="button"
          onClick={onPrevious}
        >
          <ArrowIcon direction="left" iconSize={IconSize.XL} />
        </button>
      )}
      <div
        className={styles['news-modal-carousel-navigation__pagination']}
        role="tablist"
      >
        {items.map((item, paginationIndex) => {
          const itemIndex = paginationStart + paginationIndex;
          const isActive = itemIndex === activeIndex;

          return (
            <button
              key={item.id}
              aria-label={String(itemIndex + 1)}
              aria-selected={isActive}
              className={cn(
                styles['news-modal-carousel-navigation__bullet'],
                isActive &&
                  styles['news-modal-carousel-navigation__bullet_active']
              )}
              role="tab"
              type="button"
              onClick={() => onSelect(itemIndex)}
            />
          );
        })}
      </div>
      {withArrows && (
        <button
          aria-label={t('news.navigation.next')}
          disabled={nextDisabled}
          className={styles['news-modal-carousel-navigation__arrow']}
          type="button"
          onClick={onNext}
        >
          <ArrowIcon direction="right" iconSize={IconSize.XL} />
        </button>
      )}
    </div>
  );
};

export default NewsModalCarouselNavigation;
